import React, { useEffect, useRef } from 'react';
import styles from './index.module.scss';

// 复刻原系统登录页特效:
//   80 颗白色星星向上漂浮 + 鼠标轨迹白色 dots 连线 + 红色 overlay 30s 色调变化
export default function LoginEffects() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let WIDTH = 0;
    let HEIGHT = 0;
    const stars = [];
    const dots = [];
    let mouseMoving = false;
    let mouseX = 0;
    let mouseY = 0;
    let mouseMoveTimer;
    let rafId;
    const INIT_STARS = 80;
    const DOTS_MIN_DIST = 2;
    const MAX_DIST_FROM_CURSOR = 50;

    const setSize = () => {
      WIDTH = window.innerWidth;
      HEIGHT = window.innerHeight;
      canvas.width = WIDTH;
      canvas.height = HEIGHT;
    };
    setSize();
    window.addEventListener('resize', setSize);

    const makeStar = (id) => {
      const r = Math.floor(Math.random() * 2) + 1;
      const alpha = (Math.floor(Math.random() * 10) + 1) / 20;
      return {
        id,
        x: Math.floor(Math.random() * WIDTH),
        y: Math.floor(Math.random() * HEIGHT),
        r,
        color: `rgba(255,255,255,${alpha})`,
      };
    };
    const drawStar = (s) => {
      ctx.fillStyle = s.color;
      ctx.shadowBlur = s.r * 2;
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.fill();
    };
    const moveStar = (s) => {
      s.y -= 0.15;
      if (s.y <= -10) s.y = HEIGHT + 10;
      drawStar(s);
    };

    const makeDot = (id, x, y) => ({
      id,
      x,
      y,
      r: Math.floor(Math.random() * 5) + 1,
      speed: 0.5,
      a: 0.5,
      aReduction: 0.005,
      dir: Math.floor(Math.random() * 140) + 200,
    });
    const drawDot = (d) => {
      ctx.fillStyle = `rgba(255,255,255,${d.a})`;
      ctx.shadowBlur = d.r * 2;
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.r, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.fill();
    };
    const getPrevDot = (id, step) => {
      if (id === 0 || id - step < 0) return null;
      return dots[id - step] || null;
    };
    const linkDot = (d) => {
      if (d.id === 0) return;
      const p1 = getPrevDot(d.id, 1);
      const p2 = getPrevDot(d.id, 2);
      const p3 = getPrevDot(d.id, 3);
      if (!p1) return;
      ctx.strokeStyle = `rgba(255,255,255,${d.a / 4})`;
      ctx.moveTo(p1.x, p1.y);
      ctx.beginPath();
      ctx.lineTo(d.x, d.y);
      if (p2) ctx.lineTo(p2.x, p2.y);
      if (p3) ctx.lineTo(p3.x, p3.y);
      ctx.stroke();
      ctx.closePath();
    };
    const moveDot = (d) => {
      d.a -= d.aReduction;
      if (d.a <= 0) {
        dots[d.id] = null;
        return;
      }
      d.x += Math.cos((d.dir * Math.PI) / 180) * d.speed;
      d.y += Math.sin((d.dir * Math.PI) / 180) * d.speed;
      drawDot(d);
      linkDot(d);
    };

    ctx.strokeStyle = 'white';
    ctx.shadowColor = 'white';
    for (let i = 0; i < INIT_STARS; i++) stars[i] = makeStar(i);
    ctx.shadowBlur = 0;

    const drawIfMouseMoving = () => {
      if (!mouseMoving) return;
      if (dots.length === 0) {
        dots[0] = makeDot(0, mouseX, mouseY);
        drawDot(dots[0]);
        return;
      }
      const prev = getPrevDot(dots.length, 1);
      if (!prev) return;
      const dx = Math.abs(prev.x - mouseX);
      const dy = Math.abs(prev.y - mouseY);
      if (dx < DOTS_MIN_DIST || dy < DOTS_MIN_DIST) return;
      const xv = (Math.random() > 0.5 ? -1 : 1) * Math.floor(Math.random() * MAX_DIST_FROM_CURSOR) + 1;
      const yv = (Math.random() > 0.5 ? -1 : 1) * Math.floor(Math.random() * MAX_DIST_FROM_CURSOR) + 1;
      const idx = dots.length;
      dots[idx] = makeDot(idx, mouseX + xv, mouseY + yv);
      drawDot(dots[idx]);
      linkDot(dots[idx]);
    };

    const animate = () => {
      ctx.clearRect(0, 0, WIDTH, HEIGHT);
      for (const s of stars) if (s) moveStar(s);
      for (const d of dots) if (d) moveDot(d);
      drawIfMouseMoving();
      rafId = requestAnimationFrame(animate);
    };

    const onMouseMove = (e) => {
      mouseMoving = true;
      mouseX = e.clientX;
      mouseY = e.clientY;
      clearTimeout(mouseMoveTimer);
      mouseMoveTimer = setTimeout(() => { mouseMoving = false; }, 100);
    };
    window.addEventListener('mousemove', onMouseMove);

    animate();

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(mouseMoveTimer);
      window.removeEventListener('resize', setSize);
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, []);

  return (
    <>
      <canvas ref={canvasRef} className={styles.canvas} />
      <div className={styles.filter} />
    </>
  );
}
